<template>
  <div class="container">
    
    <h3>Add Named Wod/Hero Wod/Open Wod</h3>
    <form>
      <div class="form-group">
        <label for="name">Wod Name</label>
        <input type="text" v-model="workout.name" class="form-control" id="name" placeholder="eg. 'DT' or Open 'Wod 15.2'">  
      </div>
      <div class="form-group">
        <label for="catagory">Wod Catagory</label>
        <select class="form-control" v-model="workout.catagory" id="catagory">
          <option>Crossfit Open</option>
          <option>Hero</option>
          <option>girls</option>
        </select> 
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea type="text" class="form-control" v-model="workout.description" id="description" rows="5"></textarea>  
      </div>
      <div class="form-group">
        <label for="resultMeasure">Result Measure</label>
        <select class="form-control" v-model="workout.resultMeasure" id="resultMeasure">
          <option>max weight lifted</option>
          <option>rounds and reps</option>
          <option>time</option>
          <option>time or reps and tiebreak</option>
          <option>total reps</option>
        </select> 
      </div>
      <div class="form-group">
        <label for="resultDesc">Result Description</label>
        <textarea type="text" class="form-control" v-model="workout.resultDesc" id="resultDesc" rows="3"></textarea>
      </div>
      <button v-if="!editWod" class="btn btn-outline-primary" @click.prevent="submitWorkout">Save WOD</button>
      <button v-if="editWod" class="btn btn-outline-success" @click.prevent="updateWorkout">Update WOD</button>
      <button v-if="editWod" class="btn btn-outline-danger" @click.prevent="updateWorkout">Delete WOD</button>
      <button v-if="editWod" class="btn btn-outline-warning" @click.prevent="resetForm">Reset Form</button>
    </form>
    <hr />
    <h3>Edit Existing Wod</h3>
    <button class="btn btn-outline-info ml-1 mb-1" v-for="wod in namedWods" :key="wod.id" @click="loadWod(wod.id)">{{wod.name}} - {{wod.catagory.slice(0,1)}}</button>
  </div>
</template>

<script>

import Toolbar from '@/components/toolbar'
import Avatar from 'vue-avatar'


export default {
  name: 'admin',
  components: {
    Toolbar
  },
  data () {
    return {
      msg: 'This is the admin page.. Add Hero, girl wods, Add Lifts, reset passwords,  etc...',
      editWod: false,
      workout: {
        name: "",
        catagory: "",
        description: "",
        resultMeasure: "",
        resultDesc: ""
      }  
    }
  },
  computed: {
    namedWods () {
      return this.$store.state.namedWods
    }
  },
  created () {
    this.$store.commit('setNamedWods')
  },
  methods: {
    submitWorkout: function () {

      let wodPayload = this.workout

      this.$store.dispatch('addWod', wodPayload)
        .then(() => {
            this.$notify({
              group: 'note',
              text: 'New Wod Added!',
              type: 'save'
            })
          //reset form...
          this.workout = {
            name: "",
            catagory: "",
            description: "",
            resultMeasure: "",
            resultDesc: ""
          }
        }).catch(err => {
          console.log(`Woops: ${err}`)
        })

    },
    loadWod: function (wodId) {
      this.workout = this.namedWods.find(wod => {
        return wod.id == wodId
      })
      this.editWod = true

    },
    resetForm: function () {
      this.editWod = false
      this.workout = {
            id: null,
            name: "",
            catagory: "",
            description: "",
            resultMeasure: "",
            resultDesc: ""
          }
      delete this.workout.id
    }
  },

}
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin.vue